import { render } from "./AddBlock.vue?vue&type=template&id=11f494c5&scoped=true"
import script from "./AddBlock.vue?vue&type=script&lang=js"
export * from "./AddBlock.vue?vue&type=script&lang=js"

import "./AddBlock.vue?vue&type=style&index=0&id=11f494c5&scoped=true&lang=scss"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f494c5"]])

export default __exports__